import { config } from '@uhg-abyss/web/tools/config';

import { useCustomQuery } from '../useCustomQuery';
import GET_FPC_GUEST_TOKEN from './GetFpcGuestToken.graphql';

export const useFpcGuestToken = (options) =>
  useCustomQuery(GET_FPC_GUEST_TOKEN, {
    ...options,
    url: config('GRAPHQL_API_URL'),
    accessor: 'getFpcGuestToken',
  });
